import { createSlice } from "@reduxjs/toolkit";
import { deleteMessages } from "services/messages/messages";

const initialState = {
    msg : {
        data: [],
        isLoading: false,
        isSuccess: false,
        errorMessage: ''
    }
}

export const deleteMessagesSlice = createSlice({
    name: 'deleteMessages',
    initialState,
    extraReducers: {
        [deleteMessages.pending]: (state) => {
            state.msg.isLoading = true;
        },
        [deleteMessages.fulfilled]: (state, { payload }) => {
            state.msg.isLoading = false;
            state.msg.isSuccess = true;
            state.msg.data = payload;
        },
        [deleteMessages.rejected]: (state, { payload }) => {
            state.msg.isLoading = false;
            state.msg.isSuccess = false;
            state.msg.errorMessage = payload
        }
    }
})

export default deleteMessagesSlice.reducer;